var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6544 2.25207C19.4095 1.18386 18.5396 0.395772 17.4922 0.278211C15.0121 0.000171237 12.5019 -0.00128005 10.0032 0.000171312C7.5041 -0.00128005 4.99344 0.000171237 2.51334 0.278211C1.46663 0.395772 0.597265 1.18386 0.352413 2.25207C0.00392259 3.7733 0 5.43387 0 7.0001C0 8.56633 0 10.2267 0.34849 11.7477C0.592929 12.8157 1.4625 13.6038 2.50983 13.7216C4.98973 13.9998 7.50018 14.0013 9.99928 13.9998C12.4988 14.0013 15.0086 13.9998 17.4883 13.7216C18.535 13.604 19.4052 12.8159 19.6501 11.7477C19.9988 10.2265 20 8.56613 20 7.0001C20 5.43387 20.0029 3.7733 19.6544 2.25207ZM7.41905 10.1176C7.41905 7.8958 7.41905 5.69719 7.41905 3.47515C9.53868 4.58586 11.6443 5.68911 13.7773 6.80666C11.6509 7.91426 9.54426 9.01087 7.41905 10.1176Z",
    fill: "#75798D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.dd26dddb00cd1d2926ff9c9b0230edae.svg";
export { ForwardRef as ReactComponent };